import React, { ReactElement, useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';

import Dialog from 'components/Dialog';
import DialogButton from 'components/DialogButton';

import CVCDatePicker from 'components/CVCDatePicker';

import { MessageApi } from 'api';
import { APIDATEFORMAT } from 'lib/config';

import styles from './BirthDateCheckDialogStyles.module.scss';

interface BirthDateCheckDialogProps {
  token: any;
  hasBirthdateBeenAnswered: boolean;
  historyId: number | string;
  historyType: string;
  onBirthDateCheck: (birthDateExists: boolean) => void;
}

function BirthDateCheckDialog({
  historyId,
  historyType,
  token,
  hasBirthdateBeenAnswered,
  onBirthDateCheck,
}: BirthDateCheckDialogProps): ReactElement {
  const [birthDateValue, setBirthdateValue] = useState(moment());
  const [failedBirthDateCheck, setFailedBirthDateCheck] = useState(false);

  function handleDateChange(value): void {
    setBirthdateValue(value);
  }

  const onSubmitDate = async () => {
    try {
      const checkDateResult = await MessageApi.checkBirthDateForPatient(
        historyId,
        historyType,
        moment(birthDateValue).format(APIDATEFORMAT),
        token
      );

      if (checkDateResult?.isBirthDate) {
        onBirthDateCheck(true);
        setFailedBirthDateCheck(false);
      } else {
        onBirthDateCheck(false);
        setFailedBirthDateCheck(true);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Dialog open={!hasBirthdateBeenAnswered} title="Please Enter Your Birth Date">
      <div className={classNames(styles.dialogBody, styles.withPadding)}>
        <CVCDatePicker onChange={handleDateChange} value={moment(birthDateValue)} />
        <DialogButton className={styles.dialogButton} onClick={onSubmitDate}>
          Submit
        </DialogButton>
        {failedBirthDateCheck && (
          <div className={styles.validationError}>
            You did not enter the birth date we have on file.
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default BirthDateCheckDialog;
